export var StatusAndamento;
(function (StatusAndamento) {
    StatusAndamento["NAO_INICIADO"] = "NAO_INICIADO";
    StatusAndamento["EM_ANDAMENTO"] = "EM_ANDAMENTO";
    StatusAndamento["CONCLUIDO"] = "CONCLUIDO";
    StatusAndamento["EM_AUDITORIA"] = "EM_AUDITORIA";
    StatusAndamento["SUSPENSO"] = "SUSPENSO";
})(StatusAndamento || (StatusAndamento = {}));
(function (StatusAndamento) {
    var mapDescricao = new Map([
        [StatusAndamento.NAO_INICIADO, 'Não Iniciado'],
        [StatusAndamento.EM_ANDAMENTO, 'Em Andamento'],
        [StatusAndamento.CONCLUIDO, 'Concluído'],
        [StatusAndamento.EM_AUDITORIA, 'Em Auditoria'],
        [StatusAndamento.SUSPENSO, 'Suspenso']
    ]);
    var mapColor = new Map([
        [StatusAndamento.NAO_INICIADO, '#EAEFF9'],
        [StatusAndamento.EM_ANDAMENTO, '#EAEFF9'],
        [StatusAndamento.CONCLUIDO, '#EAF2EA'],
        [StatusAndamento.EM_AUDITORIA, '#ED6C020A'],
        [StatusAndamento.SUSPENSO, '#D32F2F0A']
    ]);
    var mapColorString = new Map([
        [StatusAndamento.NAO_INICIADO, '#000000'],
        [StatusAndamento.EM_ANDAMENTO, '#000000'],
        [StatusAndamento.CONCLUIDO, '#123214'],
        [StatusAndamento.EM_AUDITORIA, '#ED6C02'],
        [StatusAndamento.SUSPENSO, '#C62828']
    ]);
    var mapSeverity = new Map([
        [StatusAndamento.NAO_INICIADO, 'info'],
        [StatusAndamento.EM_ANDAMENTO, 'info'],
        [StatusAndamento.CONCLUIDO, 'success'],
        [StatusAndamento.EM_AUDITORIA, 'warning'],
        [StatusAndamento.SUSPENSO, 'error']
    ]);
    function getDescricao(status) {
        return mapDescricao.get(status);
    }
    StatusAndamento.getDescricao = getDescricao;
    function getColor(status) {
        return mapColor.get(status);
    }
    StatusAndamento.getColor = getColor;
    function getColorString(status) {
        return mapColorString.get(status);
    }
    StatusAndamento.getColorString = getColorString;
    function getSeverity(status) {
        return mapSeverity.get(status);
    }
    StatusAndamento.getSeverity = getSeverity;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    StatusAndamento.getOptions = getOptions;
})(StatusAndamento || (StatusAndamento = {}));
